const iconData = (state = {}, action) => {
  switch (action.type) {
    case 'HYDRATE_ICON_DATA': {
      return {
        ...state,
        ...action.data,
      };
    }

    default:
      return state;
  }
};

export default iconData;
